import { Link } from "react-router-dom";
import Seo from "@/components/Seo";
import PageIntro from "@/components/PageIntro";

export default function NotFoundPage() {
  return <main data-testid="not-found-page">
    <Seo />
    <PageIntro crumbs={[{ label: "Home", to: "/" }, { label: "Page not found" }]} eyebrow="404" lines={["Page not found"]}>
      <span data-testid="not-found-message">This page could not be found.</span>
      <span className="mt-6 flex flex-wrap gap-5">
        <Link to="/" data-testid="not-found-home" className="font-semibold text-marian underline underline-offset-4 transition-colors hover:text-midnight">Return home</Link>
        <Link to="/rosary" data-testid="not-found-rosary" className="font-semibold text-marian underline underline-offset-4 transition-colors hover:text-midnight">Pray the Rosary</Link>
      </span>
    </PageIntro>
  </main>;
}